import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInvoiceType } from "src/models/Accounting/InvoiceTypes.models";

interface InvoiceTypeState {
  invoiceTypes: IInvoiceType[];
  invoiceTypeToEdit: IInvoiceType | null;
}

const initialState: InvoiceTypeState = {
  invoiceTypes: [],
  invoiceTypeToEdit: null,
};

const InvoiceTypeSlice = createSlice({
  name: "InvoiceType",
  initialState,
  reducers: {
    setInvoiceTypeList: (state, action: PayloadAction<IInvoiceType[]>) => {
      state.invoiceTypes = action.payload;
    },
    concatListInvoiceType: (
      state: InvoiceTypeState,
      action: PayloadAction<IInvoiceType[]>
    ) => {
      state.invoiceTypes = [...state.invoiceTypes.concat(action.payload)];
    },
    setInvoiceTypeToEdit: (state, action: PayloadAction<IInvoiceType | null>) => {
      state.invoiceTypeToEdit = action.payload;
    },
    addInvoiceType: (state, action: PayloadAction<IInvoiceType>) => {
      state.invoiceTypes.push(action.payload);
    },
    updateInvoiceType: (state, action: PayloadAction<IInvoiceType>) => {
      let itemIndex = state.invoiceTypes.findIndex(
        item => item.invoiceTypeId === action.payload.invoiceTypeId
      );
      if (itemIndex !== -1) state.invoiceTypes[itemIndex] = action.payload;
    },
    deleteInvoiceType: (state, action: PayloadAction<number>) => {
      const newArray = state.invoiceTypes.filter(
        item => item.invoiceTypeId !== action.payload
      );
      state.invoiceTypes = newArray;
    },
  },
});

export const {
  setInvoiceTypeList,
  concatListInvoiceType,
  setInvoiceTypeToEdit,
  addInvoiceType,
  updateInvoiceType,
  deleteInvoiceType,
} = InvoiceTypeSlice.actions;

export default InvoiceTypeSlice.reducer;
